export const getPlatformName = (
  platformId: string,
  platformNames: {[platformId: string]: string} = {},
) => platformNames[platformId] || platformId;
